/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CsvLargeFileLimitSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('CSV_LARGE_FILE_LIMIT')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([codecNumber, codecString])),
    ],
]);
export class CsvLargeFileLimitSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CsvLargeFileLimitSettingParser.decode(input).map(res => new CsvLargeFileLimitSetting(res));
    }
    static unsafeDecode(input) {
        return CsvLargeFileLimitSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CsvLargeFileLimitSettingParser.encode(data);
    }
    static schema() {
        return CsvLargeFileLimitSettingParser.schema();
    }
}
